import React, { useState } from 'react';

import DownloadProfile from '../Widgets/DownloadProfile';
import Notes from '../Widgets/Notes';
import SAE from '../Widgets/StudentAccessAndEarningsClassification/SAE';
import RaceEthnicity from '../Widgets/StudentAccessAndEarningsClassification/RaceEthnicity';
import PellPercentage from '../Widgets/StudentAccessAndEarningsClassification/PellPercentage';
import ScorecardData from '../Widgets/StudentAccessAndEarningsClassification/ScorecardData';
import OutcomesEightYearsAfterAttending from '../Widgets/StudentAccessAndEarningsClassification/OutcomesEightYearsAfterAttending';
import PanelTitle from './PanelTitle';
import Panel from './Panel';
import MethodologySimilarLinks from '../Widgets/MethodologySimilarLinks';

export default function StudentAccessAndEarnings(props) {
    const institutionData = props.institutionData;

    return (
        <Panel className="student-access-and-earnings">
            <div className="row">
                <div className="col-xs-12 col-sm-9">
                    <PanelTitle>Student Access and Earnings Classification</PanelTitle>
                </div>
                <div className="col-xs-12 col-sm-3">
                    <DownloadProfile institutionData={institutionData} />
                </div>
            </div>
            <div className="row my-4">
                <div className="col-xs-12 ">
                    <div className='p-4 emphasisBox'>
                        <div className="">
                            <div className='row'>
                                <div className="col-xs-12 col-sm-9">
                                    <div>
                                        <strong>Student Access and Earnings Classification:</strong><br />
                                        {institutionData.post_meta.saec2025.label}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <MethodologySimilarLinks
                                        methodologyLink={'/carnegie-classification/2025-social-and-economic-mobility-classification/'}
                                        similarLink={`/institutions/?saec2025[]=${institutionData.post_meta.saec2025.value}`}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-xs-12 mb-4">
                    {/* Professions Doctorate/Undergraduate Medium/Small Institutions Widget */}
                    <SAE institutionData={institutionData} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6  mb-4">
                    {/* Race/Ethnicity Widget */}
                    <RaceEthnicity institutionData={institutionData} />
                </div>

                <div className="col-lg-6  mb-4">
                    {/* Pell Percentage Widget */}
                    <PellPercentage institutionData={institutionData} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6  mb-4">
                    {/* Outcomes 8 Years After Attending Widget */}
                    <OutcomesEightYearsAfterAttending institutionData={institutionData} />
                </div>

                <div className="col-lg-6  mb-4">
                    {/* Earnings Outcomes Widget */}
                    <ScorecardData institutionData={institutionData} />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6  mb-4">
                    <Notes field="sae-tab-notes" institutionData={institutionData} />
                </div>
            </div>
        </Panel>
    );
}